/** @format */

export const marketingNavigationItems = [
    {
        key: "EzMarketing_TimeTracking_GPSMobileApp",
        EzMarketingPageAssetId: 'GPS_MOBILE',
        title: 'How GPS Works',
        link: '/time-tracking/gps-time-clock.html',
        altLink: '/marketing/gps-time-clock.html',
        type: 'absolute'
    },
    {
        key: "EzMarketing_TimeTracking_MobileTimeClockApps",
        EzMarketingPageAssetId: 'MOBILE_TIME_CLOCK_APPS',
        title: 'Mobile Apps',
        link: '/time-tracking/mobile-time-clock-apps.html',
        altLink: '/marketing/mobile-time-clock-apps.html',
        type: 'absolute'
    },
    {
        key: "EzMarketing_TimeTracking_Integrations",
        EzMarketingPageAssetId: 'INTEGRATIONS',
        title: 'Integrations',
        // TODO: Uncomment the link below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        // link: '/time-tracking/integrations.html',
        link: '/time-tracking/integrations/index.html',
        // TODO: Uncomment the link below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        // altLink: '/marketing/integrations.html',
        altLink: '/time-tracking/integrations/index.html',
        type: 'absolute'
    },
];
